/**
 * Catálogo pesquisável do hub de Configurações.
 * path = rota base; section = id do submenu/módulo (query ?s=).
 */

export const CONFIG_ROUTE_HOME = '/configuracoes';
export const CONFIG_ROUTE_PROCESSOS = '/configuracoes/processos';
export const CONFIG_ROUTE_GO = '/configuracoes/go';
export const CONFIG_ROUTE_USUARIOS = '/configuracoes/usuarios';
export const CONFIG_ROUTE_CUSTOMERS = '/configuracoes/customers';
export const CONFIG_ROUTE_EMPRESA = '/configuracoes/empresa';
export const CONFIG_ROUTE_PAINEL_CONTROLE = '/configuracoes/painel-controle';
export const INTEGRACOES_ROUTE_BASE = '/configuracoes/integracoes';
export const INTEGRACOES_ROUTE_LOGISTICA = '/configuracoes/integracoes/1';
export const INTEGRACOES_ROUTE_AREA_TECNICA = '/configuracoes/integracoes/2';

/**
 * @param {string|null|undefined} fallback
 * @param {string[]|null} allowed
 */
export function readConfigSectionParam(fallback, allowed = null) {
  try {
    if (typeof window === 'undefined') return fallback;
    const s = new URLSearchParams(window.location.search).get('s');
    if (!s) return fallback;
    if (Array.isArray(allowed) && allowed.length && !allowed.includes(s)) return fallback;
    return s;
  } catch {
    return fallback;
  }
}

export function buildConfigHref(path, section) {
  if (!section) return path;
  return `${path}?s=${encodeURIComponent(section)}`;
}

/**
 * @param {{ hasGo?: boolean, hasCustomers?: boolean, showStorage?: boolean }} opts
 */
export function buildConfigHubCatalog(opts = {}) {
  const { hasGo = false, hasCustomers = false, showStorage = false } = opts;
  const entries = [
    {
      id: 'mod-process',
      kind: 'MÓDULO',
      label: 'Processos',
      pathLabel: 'Operação',
      href: CONFIG_ROUTE_PROCESSOS,
      keywords: 'processos status sla abertura atendimento area tecnica oficina',
    },
    {
      id: 'proc-status',
      kind: 'CONFIG',
      label: 'Configuração de status',
      pathLabel: 'Processos › Área técnica',
      href: buildConfigHref(CONFIG_ROUTE_PROCESSOS, 'config-status-2'),
      keywords: 'status processos operacional automacao',
    },
    {
      id: 'proc-colunas',
      kind: 'CONFIG',
      label: 'Configuração de colunas',
      pathLabel: 'Processos › Área técnica',
      href: buildConfigHref(CONFIG_ROUTE_PROCESSOS, 'coluna-em-aberto'),
      keywords: 'colunas em aberto board',
    },
    {
      id: 'proc-condicoes',
      kind: 'CONFIG',
      label: 'Condições de intervenção',
      pathLabel: 'Processos › Área técnica',
      href: buildConfigHref(CONFIG_ROUTE_PROCESSOS, 'condicoes-intervencao'),
      keywords: 'condicoes intervencao',
    },
    {
      id: 'proc-defeitos',
      kind: 'CONFIG',
      label: 'Defeitos',
      pathLabel: 'Processos › Área técnica',
      href: buildConfigHref(CONFIG_ROUTE_PROCESSOS, 'defeitos-verve'),
      keywords: 'defeitos verve',
    },
    {
      id: 'proc-especialidade',
      kind: 'CONFIG',
      label: 'Especialidade técnica',
      pathLabel: 'Processos › Área técnica',
      href: buildConfigHref(CONFIG_ROUTE_PROCESSOS, 'cadastros-marcas-subgrupos'),
      keywords: 'especialidade marcas subgrupos',
    },
    {
      id: 'proc-email',
      kind: 'CONFIG',
      label: 'Notificações por email',
      pathLabel: 'Processos › Área técnica',
      href: buildConfigHref(CONFIG_ROUTE_PROCESSOS, 'notificacoes-email'),
      keywords: 'notificacoes email',
    },
    {
      id: 'proc-oficina',
      kind: 'CONFIG',
      label: 'Processos e exibições',
      pathLabel: 'Processos › Oficina',
      href: buildConfigHref(CONFIG_ROUTE_PROCESSOS, 'oficina'),
      keywords: 'oficina processos exibicoes',
    },
    {
      id: 'mod-users',
      kind: 'MÓDULO',
      label: 'Usuários',
      pathLabel: 'Sua empresa',
      href: CONFIG_ROUTE_USUARIOS,
      keywords: 'usuarios contas papeis permissoes canny',
    },
    {
      id: 'mod-empresa',
      kind: 'MÓDULO',
      label: 'Empresa',
      pathLabel: 'Sua empresa',
      href: CONFIG_ROUTE_EMPRESA,
      keywords: 'empresa marca dados institucionais',
    },
    {
      id: 'mod-painel',
      kind: 'MÓDULO',
      label: 'Painel de controle',
      pathLabel: 'Sua empresa',
      href: CONFIG_ROUTE_PAINEL_CONTROLE,
      keywords: 'painel controle oauth armazenamento',
    },
    {
      id: 'painel-oauth',
      kind: 'CONFIG',
      label: 'Autenticação OAuth',
      pathLabel: 'Painel de controle',
      href: buildConfigHref(CONFIG_ROUTE_PAINEL_CONTROLE, 'oauth'),
      keywords: 'oauth google autenticacao',
    },
  ];

  if (showStorage) {
    entries.push({
      id: 'painel-storage',
      kind: 'CONFIG',
      label: 'Armazenamento',
      pathLabel: 'Painel de controle',
      href: buildConfigHref(CONFIG_ROUTE_PAINEL_CONTROLE, 'storage'),
      keywords: 'armazenamento s3 storage',
    });
  }

  if (hasGo) {
    entries.push(
      {
        id: 'mod-go',
        kind: 'MÓDULO',
        label: 'Go',
        pathLabel: 'Ecosistema Vervify',
        href: CONFIG_ROUTE_GO,
        keywords: 'go app movel dispositivos campo',
      },
      {
        id: 'go-usuarios',
        kind: 'CONFIG',
        label: 'Usuários (Go)',
        pathLabel: 'Go',
        href: buildConfigHref(CONFIG_ROUTE_GO, 'usuarios'),
        keywords: 'go usuarios',
      },
      {
        id: 'go-dispositivos',
        kind: 'CONFIG',
        label: 'Dispositivos',
        pathLabel: 'Go',
        href: buildConfigHref(CONFIG_ROUTE_GO, 'dispositivos'),
        keywords: 'go dispositivos instalacao',
      },
      {
        id: 'go-custom',
        kind: 'CONFIG',
        label: 'Customização (Go)',
        pathLabel: 'Go',
        href: buildConfigHref(CONFIG_ROUTE_GO, 'customizacao'),
        keywords: 'go customizacao marca',
      },
      {
        id: 'go-processos',
        kind: 'CONFIG',
        label: 'Processos (Go)',
        pathLabel: 'Go',
        href: buildConfigHref(CONFIG_ROUTE_GO, 'processos'),
        keywords: 'go processos',
      },
      {
        id: 'go-medicoes',
        kind: 'CONFIG',
        label: 'Medições',
        pathLabel: 'Go',
        href: buildConfigHref(CONFIG_ROUTE_GO, 'medicoes'),
        keywords: 'go medicoes',
      }
    );
  }

  if (hasCustomers) {
    entries.push(
      {
        id: 'mod-customers',
        kind: 'MÓDULO',
        label: 'Customers',
        pathLabel: 'Ecosistema Vervify',
        href: CONFIG_ROUTE_CUSTOMERS,
        keywords: 'customers portal cliente',
      },
      {
        id: 'cmc-usuarios',
        kind: 'CONFIG',
        label: 'Clientes',
        pathLabel: 'Customers › Cadastros',
        href: buildConfigHref(CONFIG_ROUTE_CUSTOMERS, 'usuarios'),
        keywords: 'customers clientes usuarios portal',
      },
      {
        id: 'cmc-transportadoras',
        kind: 'CONFIG',
        label: 'Transportadoras',
        pathLabel: 'Customers › Cadastros',
        href: buildConfigHref(CONFIG_ROUTE_CUSTOMERS, 'transportadoras'),
        keywords: 'transportadoras',
      },
      {
        id: 'cmc-manual',
        kind: 'CONFIG',
        label: 'Manual do cliente',
        pathLabel: 'Customers › Cadastros',
        href: buildConfigHref(CONFIG_ROUTE_CUSTOMERS, 'manual-cliente'),
        keywords: 'manual cliente documentacao',
      },
      {
        id: 'cmc-chat',
        kind: 'CONFIG',
        label: 'Chat',
        pathLabel: 'Customers › Processos',
        href: buildConfigHref(CONFIG_ROUTE_CUSTOMERS, 'chat'),
        keywords: 'chat customers',
      },
      {
        id: 'cmc-experiencia',
        kind: 'CONFIG',
        label: 'Experiência do cliente',
        pathLabel: 'Customers › Processos',
        href: buildConfigHref(CONFIG_ROUTE_CUSTOMERS, 'experiencia'),
        keywords: 'experiencia cliente cx',
      },
      {
        id: 'cmc-permissoes',
        kind: 'CONFIG',
        label: 'Permissões',
        pathLabel: 'Customers › Processos',
        href: buildConfigHref(CONFIG_ROUTE_CUSTOMERS, 'permissoes'),
        keywords: 'permissoes customers',
      },
      {
        id: 'cmc-processos',
        kind: 'CONFIG',
        label: 'Processos (Customers)',
        pathLabel: 'Customers › Processos',
        href: buildConfigHref(CONFIG_ROUTE_CUSTOMERS, 'processos'),
        keywords: 'processos customers',
      },
      {
        id: 'cmc-avisos',
        kind: 'CONFIG',
        label: 'Publicações e avisos',
        pathLabel: 'Customers › Comunicação',
        href: buildConfigHref(CONFIG_ROUTE_CUSTOMERS, 'publicacoes-avisos'),
        keywords: 'publicacoes avisos',
      },
      {
        id: 'cmc-oauth',
        kind: 'CONFIG',
        label: 'Autenticação OAuth (Customers)',
        pathLabel: 'Customers › Configurações',
        href: buildConfigHref(CONFIG_ROUTE_CUSTOMERS, 'oauth'),
        keywords: 'oauth customers',
      },
      {
        id: 'cmc-custom',
        kind: 'CONFIG',
        label: 'Customização (Customers)',
        pathLabel: 'Customers › Configurações',
        href: buildConfigHref(CONFIG_ROUTE_CUSTOMERS, 'customizacao'),
        keywords: 'customizacao customers',
      },
      {
        id: 'cmc-email',
        kind: 'CONFIG',
        label: 'Contatos',
        pathLabel: 'Customers › Configurações',
        href: buildConfigHref(CONFIG_ROUTE_CUSTOMERS, 'email'),
        keywords: 'contatos email customers',
      },
      {
        id: 'mod-integracoes',
        kind: 'MÓDULO',
        label: 'Integrações',
        pathLabel: 'Ecosistema Vervify',
        href: INTEGRACOES_ROUTE_BASE,
        keywords: 'integracoes conexoes',
      },
      {
        id: 'int-logistica',
        kind: 'CONFIG',
        label: 'Logística e estoque',
        pathLabel: 'Integrações',
        href: INTEGRACOES_ROUTE_LOGISTICA,
        keywords: 'logistica estoque',
      },
      {
        id: 'int-area',
        kind: 'CONFIG',
        label: 'Área Técnica',
        pathLabel: 'Integrações',
        href: INTEGRACOES_ROUTE_AREA_TECNICA,
        keywords: 'area tecnica integracao',
      }
    );
  }

  return entries;
}

/**
 * Resolve o rótulo do módulo/submenu atual para o breadcrumb da topbar.
 * @param {{ catalog: ReturnType<typeof buildConfigHubCatalog>, pathname: string, search?: string }} args
 */
export function resolveConfigBreadcrumbModule({ catalog, pathname, search = '' }) {
  const path = String(pathname || '').replace(/\/$/, '') || '/';
  const s = new URLSearchParams(search).get('s');
  const target = s ? buildConfigHref(path, s) : path;
  const exact = (catalog || []).find((e) => e.href === target);
  if (exact && exact.kind === 'CONFIG') return exact.label;
  if (s) {
    const bySection = (catalog || []).find(
      (e) => e.kind === 'CONFIG' && e.href === buildConfigHref(path, s)
    );
    if (bySection) return bySection.label;
  }
  return null;
}

function normalize(text) {
  return String(text || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

/**
 * @param {ReturnType<typeof buildConfigHubCatalog>} catalog
 * @param {string} query
 */
export function searchConfigHubCatalog(catalog, query) {
  const q = normalize(query);
  if (!q) {
    const modules = catalog.filter((i) => i.kind === 'MÓDULO');
    const configs = catalog.filter((i) => i.kind !== 'MÓDULO');
    return [...modules, ...configs].slice(0, 14);
  }
  const tokens = q.split(/\s+/).filter(Boolean);
  return catalog
    .map((item) => {
      const hay = normalize(`${item.label} ${item.pathLabel} ${item.keywords || ''} ${item.kind}`);
      let score = 0;
      for (const t of tokens) {
        if (!hay.includes(t)) return null;
        if (normalize(item.label).startsWith(t)) score += 4;
        else if (normalize(item.label).includes(t)) score += 3;
        else score += 1;
      }
      return { item, score };
    })
    .filter(Boolean)
    .sort((a, b) => b.score - a.score || a.item.label.localeCompare(b.item.label, 'pt-BR'))
    .map((r) => r.item)
    .slice(0, 40);
}
